import { render, staticRenderFns } from "./EditHotel.vue?vue&type=template&id=47f770d0&scoped=true"
import script from "./EditHotel.vue?vue&type=script&lang=js"
export * from "./EditHotel.vue?vue&type=script&lang=js"
import style0 from "./EditHotel.vue?vue&type=style&index=0&id=47f770d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f770d0",
  null
  
)

export default component.exports